(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["clearance-landing"] && !Shopify.designMode) return;
  try {
    
(function () {
  var params = new URLSearchParams(window.location.search);
  var focus = params.get('focus');
  var attribution = {
    utm_source: params.get('utm_source') || '',
    utm_medium: params.get('utm_medium') || '',
    utm_campaign: params.get('utm_campaign') || '',
    utm_content: params.get('utm_content') || '',
    focus: focus || '',
    landed_at: new Date().toISOString(),
    landing_path: window.location.pathname
  };

  if (attribution.utm_campaign || attribution.focus) {
    try {
      localStorage.setItem('cl_attribution', JSON.stringify(attribution));
      var expiry = new Date(Date.now() + 30 * 864e5).toUTCString();
      document.cookie = 'cl_campaign=' + encodeURIComponent(attribution.utm_campaign || 'clearance') + '; expires=' + expiry + '; path=/; SameSite=Lax';
    } catch (e) {}
  }

  if (focus) {
    var card = document.getElementById('cl-card-' + focus);
    if (card) {
      card.classList.add('cl-featured');
      var title = document.getElementById('cl-title');
      var cardTitle = card.querySelector('.cl-card-title');
      if (title && cardTitle) {
        title.textContent = cardTitle.textContent + ' — Final Stock, Reserved Pricing For You';
      }
      setTimeout(function () {
        card.scrollIntoView({ behavior: 'smooth', block: 'center' });
      }, 350);
    }
  }

  function track(eventName, data) {
    try {
      var payload = Object.assign({ event: eventName, ts: new Date().toISOString() }, attribution, data || {});
      var existing = JSON.parse(localStorage.getItem('cl_events') || '[]');
      existing.push(payload);
      localStorage.setItem('cl_events', JSON.stringify(existing.slice(-50)));
      if (window.ShopifyAnalytics && window.ShopifyAnalytics.lib && window.ShopifyAnalytics.lib.track) {
        window.ShopifyAnalytics.lib.track('Clearance ' + eventName, payload);
      }
    } catch (e) {}
  }

  try {
    fetch('/discount/{{ section.settings.discount_code | url_encode }}', { credentials: 'same-origin' });
  } catch (e) {}

  track('landing_view', {});

  document.querySelectorAll('[data-cl-track]').forEach(function (el) {
    el.addEventListener('click', function () {
      track(el.getAttribute('data-cl-track'), { product: el.getAttribute('data-cl-product') });
    });
  });

  document.querySelectorAll('[data-cl-add]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var variantId = btn.getAttribute('data-cl-add');
      track('add_to_cart', { product: btn.getAttribute('data-cl-product'), variant: variantId });
      btn.textContent = 'Adding…';
      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          items: [{ id: parseInt(variantId, 10), quantity: 1 }],
          attributes: { cl_campaign: attribution.utm_campaign || 'clearance', cl_focus: attribution.focus }
        })
      })
        .then(function (r) { return r.json(); })
        .then(function () {
          btn.textContent = 'Added ✓';
          setTimeout(function () { window.location.href = '/cart'; }, 600);
        })
        .catch(function () {
          btn.textContent = 'Add to cart';
        });
    });
  });

  var noteForm = document.querySelector('form[action="/cart"]');
  try {
    fetch('/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ attributes: { cl_utm_campaign: attribution.utm_campaign, cl_utm_content: attribution.utm_content, cl_focus: attribution.focus } })
    });
  } catch (e) {}
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
